package com.fireavert.events.mark_as_test.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class MarkAsTestResponse(val success: Boolean? = null)